module.exports = __webpack_public_path__ + "img/max-person-subtract.e724edc6.svg";